import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './DetailsStyle.css';

function DetailsPage() {

  const location = useLocation();
  const [msisdn, setMsisdn] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);

  useEffect(() => {
    const { msisdn, list, empty } = location.state || {};

    if (msisdn) setMsisdn(msisdn);

    if (empty) {
      setIsEmpty(true);
    } else if (list && list.length > 0) {
      setTableData(list);
      setIsEmpty(false);
    }
  }, []);

  // Display-only tidy: group digits and add the IQD unit for numeric amounts.
  // Any non-numeric or empty value is shown exactly as it came back.
  const formatAmount = (value) => {
    if (value === null || value === undefined || String(value).trim() === '') return '—';
    const numeric = Number(String(value).replace(/,/g, '').trim());
    return Number.isFinite(numeric) ? `${numeric.toLocaleString('en-US')} IQD` : String(value);
  };

  const showValue = (value) => {
    if (value === null || value === undefined || String(value).trim() === '') return '—';
    return String(value);
  };

  return (
    <div className='details'>
      <header className="cc-topbar">
        <div className="cc-brand">
          <svg className="cc-mark" viewBox="0 0 48 48" aria-hidden="true">
            <g fill="none" stroke="currentColor" strokeWidth="1.6">
              <circle cx="24" cy="24" r="3.4" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(45 24 24)" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(90 24 24)" />
              <ellipse cx="24" cy="24" rx="5.4" ry="15" transform="rotate(135 24 24)" />
            </g>
          </svg>
          <div className="cc-lock">
            <b>AL&middot;HORIZON</b>
            <span>Customer Care</span>
          </div>
        </div>
        <div className="cc-partner">Operated for Zain Iraq</div>
      </header>

      <div className='details-body'>
        <button type="button" className="cc-btn-link details-back" onClick={() => window.history.back()}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true"><path d="M19 12H5M11 18l-6-6 6-6" /></svg>
          Back to overview
        </button>

        <div className='details-head'>
          <h1>Transaction log</h1>
          {msisdn ? <span className='details-msisdn'>{msisdn}</span> : null}
        </div>

        <div className='details-card'>
          <div className='table-container'>
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Action</th>
                  <th>Amount</th>
                  <th>Method</th>
                </tr>
              </thead>
              <tbody>
                {isEmpty ? (
                  <tr>
                    <td colSpan='4' className='details-empty'>No data found</td>
                  </tr>
                ) : (
                  tableData.map((row, index) => (
                    <tr key={index}>
                      <td className='mono'>{showValue(row.date)}</td>
                      <td className='details-action'>{showValue(row.action)}</td>
                      <td className='mono'>{formatAmount(row.amount)}</td>
                      <td>{showValue(row.method)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );

}
export default DetailsPage;
